import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from 'src/common';
import { RootState } from 'src/reducers';
import { selectUserId } from 'src/store/selectors';
import { reportsMapDispatchToProps, reportsMapStateToProps } from '../clients/client/reportsV2/container';
import { ClientReportsActionTypes } from '../clients/client/reportsV2/store/thunks';
import { ClientListActionTypes, fetchClientList } from '../clients/list/store/thunks';
import { initiateBulkRequest } from './batch/store/thunks';
import { ReportingComponent } from './components/ReportingComponent';
import { selectBulkReporting, selectReporting, selectReportingReports } from './store/selectors';
import { reportingSlice } from './store/slice';
import {
  createBulkReport,
  deleteBulkReport,
  deleteReportingParameter,
  deleteScheduledEvent,
  downloadBulkJobsCsv,
  fetchAfsls,
  fetchBulkReportList,
  fetchFilteredClients,
  fetchModelList,
  fetchReportingParameters,
  fetchScheduledEventList,
  fetchSecurities,
  getImmediateBulkReportById,
  ReportingActionTypes,
  setReportingParameterSystemShare,
  updateBulkReport,
} from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  ...reportsMapStateToProps(state),
  reporting: selectReporting(state),
  bulk: selectBulkReporting(state),
  reports: selectReportingReports(state),
  userId: selectUserId(state),
  afslsProgress: progressSelectorFactory([ReportingActionTypes.FetchAfsls])(state),
  securitiesProgress: progressSelectorFactory([ReportingActionTypes.FetchSecurities])(state),
  modelsProgress: progressSelectorFactory([ReportingActionTypes.FetchModelList])(state),
  portfoliosProgress: progressSelectorFactory([ReportingActionTypes.FetchFilteredClients])(state),
  createBulkReportProgress: progressSelectorFactory([ReportingActionTypes.CreateBulkReport])(state),
  updateBulkReportProgress: progressSelectorFactory([ReportingActionTypes.UpdateBulkReport])(state),
  deleteBulkReportProgress: progressSelectorFactory([ReportingActionTypes.DeleteBulkReport])(state),
  fetchBulkReportListProgress: progressSelectorFactory([ReportingActionTypes.FetchBulkReportList])(state),
  clientListProgress: progressSelectorFactory([ClientListActionTypes.FetchClientList])(state),
  fetchScheduledEventListProgress: progressSelectorFactory([ReportingActionTypes.FetchScheduledEventList])(state),
  deleteScheduledEventProgress: progressSelectorFactory([ReportingActionTypes.DeleteScheduledEvent])(state),
  fetchReportParametersListProgress: progressSelectorFactory([ClientReportsActionTypes.GetReportParametersList])(state),
  fetchReportingParametersProgress: progressSelectorFactory([ReportingActionTypes.ReportParamListTemplates])(state),
  setReportingParameterSystemShareProgress: progressSelectorFactory([ReportingActionTypes.ReportParamSetSystemShare])(state),
});

const mapDispatchToProps = {
  ...reportingSlice.actions,
  ...reportsMapDispatchToProps,
  fetchAfsls,
  fetchSecurities,
  fetchModelList,
  fetchClientList,
  fetchFilteredClients,
  fetchScheduledEventList,
  getImmediateBulkReportById,
  createBulkReport,
  updateBulkReport,
  deleteBulkReport,
  initiateBulkRequest,
  fetchBulkReportList,
  fetchReportingParameters,
  deleteScheduledEvent,
  setReportingParameterSystemShare,
  deleteReportingParameter,
  downloadBulkJobsCsv,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const ReportingContainer = connector(ReportingComponent);
